import { Grid, makeStyles } from "@material-ui/core";
import "./ExperienceUI.css";
import Fab from "@material-ui/core/Fab";
import React from "react";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import MapOutlinedIcon from "@material-ui/icons/MapOutlined";
import AirplayOutlinedIcon from "@material-ui/icons/AirplayOutlined";
import SideMenu from "../../../components/sidemenu/SideMenu";
import CustomModal from "../../../components/modal/CustomModal";
import Minimap from "../../../components/miniMap/Minimap";
import MyCustomModal from "../../../components/modal/MyCustomModal";
import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import { liveStreamData } from "../scene/Database";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1,
  },
  controls: {
    position: "relative",
    zIndex: 2,
  },
  tutorialPopup: {
    textAlign: "center",
    padding: "2rem",
    background: "#ffffff8c",
    borderRadius: "3px",
    backdropFilter: "saturate(180%) blur(20px)",
    maxWidth: "400px",
  },
}));

const TutorialActionButton = (props) => (
  <div style={{ padding: "1rem", textAlign: "center" }}>
    <Button
      variant={"contained"}
      disableElevation
      color={"primary"}
      onClick={() => props.action(false)}
    >
      {props.text}
    </Button>
  </div>
);

const ExperienceUI = (props) => {
  const classes = useStyles();

  const {
    setCurrentLocation,
    minimapData,
    goToHome,
    goToFirstFloor,
    moveToWayPoint,
    logLeaderBoard
  } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const [modalData, setModalData] = React.useState(null);
  const [openMinimap, setOpenMinimap] = React.useState(false);
  const [showKeynote, setShowKeynote] = React.useState(false);
  const [keynoteContext, setKeynoteContext] = React.useState({
    videoLink: "",
    chatLink: "",
  });

  const [tutorialStarted, setTutorialStarted] = React.useState(false);
  const [endTutorial, setEndTutorial] = React.useState(false);
  const [tutorialMenuDisabled, setTutorialMenuDisabled] = React.useState(true);
  const [tutorialHomeDisabled, setTutorialHomeDisabled] = React.useState(true);
  const [tutorialKeynoteDisabled, setTutorialKeynoteDisabled] =
    React.useState(true);
  const [tutorialMinimapDisabled, setTutorialMinimapDisabled] =
    React.useState(true);
  const [tutorialCounter, setTutorialCounter] = React.useState(0);

  const tutorialInfo = [
    {
      action: setTutorialMenuDisabled,
      info: "Tap or click here to access agenda, leaderboard or help",
    },
    {
      action: setTutorialKeynoteDisabled,
      info: "Tap or click here to watch keynote sessions",
    },
    {
      action: setTutorialMinimapDisabled,
      info: "Tap or click here to go to different places",
    },
    {
      action: setTutorialHomeDisabled,
      info: "Tap or click here to go to the starting position in the experience",
    },
  ];

  const handleMinimapClose = () => setOpenMinimap(false);
  const toggleMinimap = () => setOpenMinimap(!openMinimap);

  const startTutorial = () => {
    setTutorialStarted(true);
    tutorialInfo[0].action(false);
  };

  const increment = () => {
    tutorialInfo[tutorialCounter + 1].action(false);
    setTutorialCounter(tutorialCounter + 1);
  };

  const endTutorialBit = () => {
    setEndTutorial(true);
    setTutorialMenuDisabled(false);
    setTutorialHomeDisabled(false);
    setTutorialKeynoteDisabled(false);
    setTutorialMinimapDisabled(false);
  };

  const startKeynote = () => {
    const today = new Date().getDate().toString();
    const videoLink = liveStreamData.get('26')?.videoURL;
    const chatLink = liveStreamData.get('26')?.chatURL;
    setKeynoteContext({ videoLink, chatLink });
    setShowKeynote(true);
    logLeaderBoard('', 'keynote', 100);
  };

  return (
    <>
      {!endTutorial && (
        <Backdrop open={true} className={classes.backdrop}>
          <div className={classes.tutorialPopup}>
            {tutorialStarted ? (
              <div>
                <h4>{tutorialInfo[tutorialCounter].info}</h4>
                {tutorialCounter < 3 ? (
                  <TutorialActionButton text={"Next"} action={increment} />
                ) : (
                  <TutorialActionButton
                    text={"Finish"}
                    action={endTutorialBit}
                  />
                )}
              </div>
            ) : (
              <div style={{ textAlign: "center" }}>
                <h2>Welcome to De Beers Forevermark Forum 2021</h2>
                <h3>Let's walk you through the environment</h3>
                <TutorialActionButton
                  text={"Start tutorial"}
                  action={startTutorial}
                />
                <h5 onClick={endTutorialBit} style={{ cursor: "pointer" }}>
                  Skip
                </h5>
              </div>
            )}
          </div>
        </Backdrop>
      )}
      <div className={classes.controls}>
        <SideMenu isTutorialDisabled={tutorialMenuDisabled} />
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          id={"btn-controls"}
          spacing={2}
        >
          <Grid item style={{ textAlign: "center" }}>
            <Fab
              color="primary"
              aria-label="add"
              size="large"
              onClick={startKeynote}
              disabled={tutorialKeynoteDisabled}
            >
              <AirplayOutlinedIcon />
            </Fab>
            Keynote
          </Grid>
          <Grid item style={{ textAlign: "center" }}>
            <Fab
              color="primary"
              aria-label="add"
              size="large"
              onClick={toggleMinimap}
              disabled={tutorialMinimapDisabled}
            >
              <MapOutlinedIcon />
            </Fab>
            Minimap
          </Grid>
          <Grid item style={{ textAlign: "center" }}>
            <Fab
              color="primary"
              aria-label="add"
              size="large"
              onClick={goToHome}
              disabled={tutorialHomeDisabled}
            >
              <HomeOutlinedIcon />
            </Fab>
            Home
          </Grid>
        </Grid>
      </div>

      <Minimap
        open={openMinimap}
        goToFirstFloor={goToFirstFloor}
        moveToWayPoint={moveToWayPoint}
        minimapData={minimapData}
        setCurrentLocation={setCurrentLocation}
        handleMinimapClose={handleMinimapClose}
      />

      <CustomModal
        url={modalData}
        show={openModal}
        onHide={() => setOpenModal(false)}
      />

      <MyCustomModal
        videoURL={keynoteContext.videoLink}
        chatURL={keynoteContext.chatLink}
        show={showKeynote}
        onHide={() => setShowKeynote(false)}
      />
    </>
  );
};

export default ExperienceUI;
